import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
export default {
  loadScript: function loadScript(src, onload) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;

      script.onload = function () {
        onload && onload();
        resolve();
      };

      document.getElementsByTagName('head')[0].appendChild(script);
    });
  }
};